// TEMP
const wallets = [{ currencyCode: 'USD', walletId: '1' }]
export const dummyConnections = {
  connected: [
    {
      id: '9f93b95e-6d39-464a-85e4-33224f390373',
      requesterAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      receiverAccount: '7eab181d-c902-4d41-afad-458f977372a0',
      connectionStatus: 'CONNECTED',
      details: {
        name: 'Connection 1',
        description: 'Known for subbrands like Connection 1A and Connection 1B.',
        logo: '123456.svg',
      },
      wallets,
    },
    {
      id: 'f6d7c814-b36c-46fb-be09-32d99637c84d',
      requesterAccount: 'aab42da6-b373-427c-8c3e-a2114e04928f',
      receiverAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      connectionStatus: 'CONNECTED',
      details: {
        name: 'Connection 2',
        description: 'Known for subbrands like Connection 2A and Connection 2B.',
        logo: '123456.svg',
      },
      wallets,
    },
    {
      id: 'aeb6c440-cb6c-48d0-98e4-0119f927ca0d',
      requesterAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      receiverAccount: '4882178d-0744-4c9b-9d63-21fb3a5844e7',
      connectionStatus: 'CONNECTED',
      details: {
        name: 'Connection 3',
        description: 'Known for subbrands like Connection 3A and Connection 3B.',
        logo: '123456.svg',
      },
      wallets,
    },
  ],
  received: [
    {
      id: '9f93b95e-6d39-464a-85e4-33224f390373',
      requesterAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      receiverAccount: '7eab181d-c902-4d41-afad-458f977372a0',
      connectionStatus: 'RECEIVED',
      details: {
        name: 'Received Connection 1',
        description: 'Known for subbrands like Received Connection 1A and Received Connection 1B.',
        logo: '123456.svg',
      },
      wallets,
    },
    {
      id: 'f6d7c814-b36c-46fb-be09-32d99637c84d',
      requesterAccount: 'aab42da6-b373-427c-8c3e-a2114e04928f',
      receiverAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      connectionStatus: 'RECEIVED',
      details: {
        name: 'Received Connection 2',
        description: 'Known for subbrands like Received Connection 2A and Received Connection 2B.',
        logo: '123456.svg',
      },
      wallets,
    },
  ],
  requested: [
    {
      id: '9f93b95e-6d39-464a-85e4-33224f390373',
      requesterAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      receiverAccount: '7eab181d-c902-4d41-afad-458f977372a0',
      connectionStatus: 'REQUESTED',
      details: {
        name: 'Sent Connection 1',
        description: 'Known for subbrands like Sent Connection 1A and Sent Connection 1B.',
        logo: '123456.svg',
      },
      wallets,
    },
    {
      id: 'f6d7c814-b36c-46fb-be09-32d99637c84d',
      requesterAccount: 'aab42da6-b373-427c-8c3e-a2114e04928f',
      receiverAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      connectionStatus: 'REQUESTED',
      details: {
        name: 'Sent Connection 2',
        description: 'Known for subbrands like Sent Connection 2A and Sent Connection 2B.',
        logo: '123456.svg',
      },
      wallets,
    },
  ],
}

export const dummyReceivedConnections = {
  connected: null,
  received: [
    {
      id: '9f93b95e-6d39-464a-85e4-33224f390373',
      requesterAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      receiverAccount: '7eab181d-c902-4d41-afad-458f977372a0',
      connectionStatus: 'RECEIVED',
      details: {
        name: 'Received Connection 1',
        description: 'Known for subbrands like Received Connection 1A and Received Connection 1B.',
        logo: '123456.svg',
      },
      wallets,
    },
    {
      id: 'f6d7c814-b36c-46fb-be09-32d99637c84d',
      requesterAccount: 'aab42da6-b373-427c-8c3e-a2114e04928f',
      receiverAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      connectionStatus: 'RECEIVED',
      details: {
        name: 'Received Connection 2',
        description: 'Known for subbrands like Received Connection 2A and Received Connection 2B.',
        logo: '123456.svg',
      },
      wallets,
    },
  ],
  requested: null,
}

export const dummySentConnections = {
  connected: null,
  received: null,
  requested: [
    {
      id: '9f93b95e-6d39-464a-85e4-33224f390373',
      requesterAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      receiverAccount: '7eab181d-c902-4d41-afad-458f977372a0',
      connectionStatus: 'REQUESTED',
      details: {
        name: 'Sent Connection 1',
        description: 'Known for subbrands like Sent Connection 1A and Sent Connection 1B.',
        logo: '123456.svg',
      },
      wallets,
    },
    {
      id: 'f6d7c814-b36c-46fb-be09-32d99637c84d',
      requesterAccount: 'aab42da6-b373-427c-8c3e-a2114e04928f',
      receiverAccount: '3d31119f-8e99-41e3-a107-bbdcca7f411c',
      connectionStatus: 'REQUESTED',
      details: {
        name: 'Sent Connection 2',
        description: 'Known for subbrands like Sent Connection 2A and Sent Connection 2B.',
        logo: '123456.svg',
      },
      wallets,
    },
  ],
}

export const noConnections = {
  connected: [],
  received: [],
  requested: [],
}

export const networkPartners = {
  content: [
    {
      account: {
        accountReference: '5a2d51aa-b52a-40c7-a9d4-87a4c6d16904',
        name: 'ByBit',
        description: 'Network member 1',
        logo: '123456.svg',
      },
      wallets,
    },
    {
      account: {
        accountReference: '7e37c70b-476e-450e-b2d0-8e89f40c2fa8',
        name: 'WinterMute',
        description: 'Network member 2',
        logo: '123456.svg',
      },
      wallets,
    },
    {
      account: {
        accountReference: '10f2bf8c-9c61-426c-84fc-83d87928af6d',
        name: 'Binance',
        description: 'Network member 3',
        logo: '123456.svg',
      },
      wallets,
    },
  ],
  pageable: {
    pageNumber: 0,
    pageSize: 10,
    sort: {
      empty: false,
      sorted: true,
      unsorted: false,
    },
    offset: 0,
    paged: true,
    unpaged: false,
  },
  last: false,
  totalPages: 4,
  totalElements: 38,
  first: true,
  size: 10,
  number: 0,
  sort: {
    empty: false,
    sorted: true,
    unsorted: false,
  },
  numberOfElements: 10,
  empty: false,
}
